import { render, staticRenderFns } from "./MainPageHeader.vue?vue&type=template&id=060b09bc&scoped=true&"
import script from "./MainPageHeader.vue?vue&type=script&lang=js&"
export * from "./MainPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainPageHeader.vue?vue&type=style&index=0&id=060b09bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b09bc",
  null
  
)

export default component.exports